import moment from 'moment'

export const getFileNameSubsidiaryReport = (subsidiaryName = '') =>
  `Reporte_${subsidiaryName}_${moment().format('MM-DD-YYYY')}.xlsx`
